import { IDiscountCreate } from "views/admin/discounts/types/discounts.interface";
import axiosInstance from "./config";

const basePath = `/induk-app/products/discounts`;

export const getDiscounts = (page?: number, search?: string) => {
  return axiosInstance.get(`${basePath}`, {
    params: {
      page,
      search,
    },
  });
};

export const addDiscount = (good: IDiscountCreate) => {
  return axiosInstance.post(`${basePath}/create`, good);
};

export const getDiscount = (slug: string) => {
  return axiosInstance.get(`${basePath}/${slug}`);
};

export const updateDiscount = (
  slug: string,
  good: Partial<IDiscountCreate>
) => {
  return axiosInstance.patch(`${basePath}/${slug}/update`, good);
};

export const deleteDiscount = (slug: string) => {
  return axiosInstance.delete(`${basePath}/${slug}/delete`);
};
